import type { EmbeddingType } from "metabase/public/lib/types";

export const STATIC_LEGACY_EMBEDDING_TYPE: EmbeddingType = "static-legacy";
export const GUEST_EMBED_EMBEDDING_TYPE: EmbeddingType = "guest-embed";
